import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NavScrollTop = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        
        // Track page view in Google Analytics
        if (typeof window.gtag !== 'undefined') {
            window.gtag('config', 'AW-17582346862', {
                page_path: location.pathname + location.search,
            });
        }
    }, [location.pathname, location.search]);

    return children;
};

export default NavScrollTop;
